import { useMemo, useState } from 'react';
import { computeLifestyleScore } from '../../../engine/lifestyleScore';

export function LifestyleCard() {
  const [commute, setCommute] = useState(50);
  const [remote, setRemote] = useState(2);
  const [home, setHome] = useState(300);
  const [privacy, setPrivacy] = useState(true);
  const res = useMemo(()=> computeLifestyleScore({ commute_km: commute, remote_days: remote, home_energy_kWh: home, privacy }), [commute, remote, home, privacy]);
  return (
    <div className="border border-evat-gold/40 rounded p-3 space-y-2">
      <div className="font-orbitron text-evat-gold">Lifestyle Score</div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-sm">
        <label className="flex items-center gap-2">Commute km
          <input type="number" value={commute} onChange={(e)=>setCommute(Number(e.target.value))} className="bg-black border border-evat-neon text-evat-neon rounded px-2 py-1 w-24"/>
        </label>
        <label className="flex items-center gap-2">Remote days
          <input type="number" min={0} max={5} value={remote} onChange={(e)=>setRemote(Number(e.target.value))} className="bg-black border border-evat-neon text-evat-neon rounded px-2 py-1 w-20"/>
        </label>
        <label className="flex items-center gap-2">Home kWh
          <input type="number" value={home} onChange={(e)=>setHome(Number(e.target.value))} className="bg-black border border-evat-neon text-evat-neon rounded px-2 py-1 w-24"/>
        </label>
        <label className="flex items-center gap-2">Privacy
          <input type="checkbox" checked={privacy} onChange={(e)=>setPrivacy(e.target.checked)} />
        </label>
      </div>
      <div className="text-neutral-300">Grade: <span className="text-evat-neon">{res.grade}</span> {res.masked && <span className="text-xs text-yellow-400 ml-2">privacy mask</span>}</div>
    </div>
  );
}

export default LifestyleCard;



















